import styled from 'styled-components';
import { DEVICES } from '_constants';

export const AgencySelectionWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-left: 10px;
  margin-bottom: 15px;
  gap: 5px;

  label {
    padding-bottom: 0;
  }

  #agency-results {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

  button {
    height: 38px;
    width: 130px;
  }

  .BaseSelect__control {
    width: 120px;

    @media ${DEVICES.laptop} {
      min-width: 120px;
    }
  }

  .BaseSelect__menu {
    font-size: 14px;
    width: 120px;
    @media ${DEVICES.laptop} {
      min-width: 12px;
    }
  }

  .BaseSelect__option {
    height: 24px;
    padding: 2px;
  }
`;

export const TitleSelectionWrapper = styled.div`
  display: flex;
  gap: 5px;
  height: 25px;

  #inspectionFailure-location,
  #proximity-place {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

  .BaseSelect__control {
    height: 20px;
    display: flex;
    align-content: center;
    font-size: 12px;
  }

  .BaseSelect__indicators {
    display: flex;
    height: 20px;
  }

  .BaseSelect__indicator {
    width: 14px;
    height: 14px;
    color: black;
    padding: 0;
  }

  .BaseSelect__value-container {
    width: 100px;
    margin: auto;
    padding-left: 2px;
  }

  .BaseSelect__menu {
    font-size: 12px;
  }

  .BaseSelect__option {
    height: 18px;
    padding: 2px;
  }

  .inspectionFailure-location {
    .BaseSelect__control {
      width: 95px;
    }
  }
  .proximity-place {
    .BaseSelect__control {
      width: 140px;
    }
  }
`;

export const HeaderSelectionWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: baseline;
  height: 24px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  margin-left: 10px;

  button {
    height: 36px;
    padding: 0 20px;
  }
`;

export const RadioGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 7px;
  gap: 5px;
`;

export const RadioItemContainer = styled.div``;

export const RadioLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 5px;
  cursor: pointer;

  &:hover {
    .radio-circle {
      border-color: #fca5a5;
    }

    .radio-label {
      color: #dc2626;
    }
  }
`;

export const RadioInputHidden = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

export const RadioCircle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 0.5px solid ${(props) => (props.isSelected ? '#ef4444' : '#d1d5db')};
  background-color: ${(props) => (props.isSelected ? '#fef2f2' : '#ffffff')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-top: 2px;
`;

export const RadioInnerCircle = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ef4444;
  opacity: ${(props) => (props.isSelected ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

export const RadioLabelText = styled.span`
  font-size: 14px;
  color: ${(props) => (props.isSelected ? '#b91c1c' : '#374151')};
  transition: color 0.2s ease;
  flex: 1;
`;

export const SubPanelContainer = styled.div`
  display: flex;
  margin-top: 12px;
  padding: 8px;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`;

export const SwatchLegendSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SwatchLegendWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;
